export default "__VITE_ASSET__BHHYkq8Q__"